import "~/misc/common";
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    $('.datetimepicker').datetimepicker().on('dp.change', function (ev) {
      $('#applyFilters').show(300);
    });
  }
}